import { Items, Item } from '@/store/deferred';
import { routeParseType } from '../utils';

export * from '@/store/deferred';

export interface IDeferredMixin {
  items: Items;
  add: (item: Item) => void;
  remove: (id: Item['id']) => void;
  saved: ({ id }: ICardId) => boolean;
  toggle: (data: any) => void;
}

export interface ICardId {
  id: string;
}

export interface ICardCode {
  code: string;
}

export interface ICardData extends ICardId, ICardCode {
  image: { small: string };
  is_locked?: boolean;
  note: string;
  title: string;
}
export interface IRouteData extends ICardId, ICardCode {}

export interface IRouteParsed {
  parse: ({ id, code }: IRouteData) => routeParseType;
}

export enum StatusEnum {
  PREPARE = 'PREPARE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface IProgressFormOpen {
  isFormOpen: boolean;
}

export interface ILoaderMixin {
  status: string;
  isError: boolean;
  isReady: boolean;
  isLoading: boolean;
  setStatus: (value: string) => void;
}

export enum FileFieldEnum {
  MAX_VOLUME = 'Объем файла превышает 5MB',
  FILE_FORMAT = 'Неверный формат файла',
}

export enum MaxFileEnum {
  MAX_FILE = 5242880,
}



// WEBPACK FOOTER //
// ./src/pages/profile/mixins/types.ts